import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { Box, DialogContent, DialogContentText, TextField } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import { TCommentDialogProps } from './types';

export const CommentDialog: FC<TCommentDialogProps> = ({
	open,
	setClose,
	handleAddComment,
	title = 'Add Comment',
	text = '',
	comments = [],
}) => {
	const [newComment, setNewComment] = React.useState<string>('');
	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary" dangerouslySetInnerHTML={{ __html: title }} />
			<DialogContent
				sx={{
					p: '0 12px 0px 12px',
				}}
			>
				<DialogContentText
					sx={{
						fontSize: '0.8rem',
						display: 'flex',
						flexDirection: 'column',
						gap: '8px',
					}}
				>
					{Array.isArray(comments) &&
						comments?.map(comment => (
							<Box
								key={nanoid()}
								sx={{
									lineHeight: '1.2',
									backgroundColor: '#cadbe6',
									color: 'primary.main',
									// opacity: '0.8',
									padding: '6px 8px',
									borderRadius: '12px',
									// color: '#000000a0',
								}}
							>
								<Box
									sx={{
										fontSize: '0.8rem',
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'space-between',
										// gap: '8px',
									}}
								>
									<b>{comment.author?.fullName || 'Unknown'}:&nbsp;</b>
									<small>
										{comment.createdAt
											? DateTime.fromISO(comment.createdAt).toFormat('yyyy-MM-dd HH.mm')
											: 'Unknown date'}
									</small>
								</Box>
								<i>{comment.comment || ''}</i>
							</Box>
						))}
				</DialogContentText>
				<DialogContentText dangerouslySetInnerHTML={{ __html: text }} />
				<TextField
					sx={{
						mt: '20px',
						'& .MuiInputBase-root': {
							padding: '6px 8px',
							lineHeight: '1.2',
							// fontSize: '0.9rem',
						},
					}}
					autoFocus
					// label="Add New Comment"
					value={newComment}
					onChange={e => setNewComment(e.target.value)}
					type="text"
					fullWidth
					multiline
					rows={3}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={setClose}
					sx={{
						textTransform: 'none',
					}}
				>
					Cancel
				</Button>
				<Button
					onClick={() => handleAddComment(newComment)}
					autoFocus
					sx={{
						textTransform: 'none',
					}}
				>
					Send
				</Button>
			</DialogActions>
		</Dialog>
	);
};
